import { Disclosure } from '@headlessui/react';
import { oneLine } from 'common-tags';

import ChevronDown from '@/icons/light/chevron-down.svg';

import type { FunctionComponent } from 'react';
import type { TypeAccordionProps } from './types';

export const Accordion: FunctionComponent<TypeAccordionProps> = ({
  className,
  title,
  children,
  variant,
  color = 'blue',
  titleStyleClass,
  descriptionStyleClass,
}: TypeAccordionProps) => {
  const isCard = color === 'card';
  const isWhite = color === 'white';
  return (
    <Disclosure
      as="div"
      className={oneLine`transition-colors duration-300 ease-in-out ${
        isCard
          ? 'border-input-border bg-neutrals-0 text-text-neutrals-900 rounded-accordion border border-solid'
          : isWhite
            ? 'border-neutrals-100 bg-neutrals-0 text-neutrals-900 hover:border-neutrals-900 border-b border-solid pb-4'
            : 'bg-primary-400 text-neutrals-0 hover:bg-primary-600 rounded'
      } ${className} `}
    >
      {({ open }) => (
        <>
          <Disclosure.Button
            className={oneLine`flex w-full items-center gap-3 ${isCard ? (open ? 'px-6 pt-6 pb-2 font-bold' : 'p-6 font-bold') : 'p-4'} text-left ${
              variant === 'link'
                ? 'text-primary-500 tracking-widest uppercase'
                : 'justify-between'
            } ${titleStyleClass ?? 'text-dropdown'} `}
          >
            {title}

            <ChevronDown
              width={18}
              height={18}
              className={oneLine`shrink-0 ${isCard || isWhite ? 'text-neutrals-900' : 'text-neutrals-0'} ${open ? 'rotate-180' : ''} `}
            />
          </Disclosure.Button>

          <Disclosure.Panel
            unmount={false}
            className={oneLine`text-body ${isCard ? 'px-6 pb-6' : 'p-4'} ${
              isCard
                ? 'text-text-neutrals-900'
                : isWhite
                  ? 'text-primary-900'
                  : 'text-neutrals-0'
            } ${descriptionStyleClass ?? 'text-body-m'} `}
          >
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

Accordion.displayName = 'Accordion';
